"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var Icon_1 = require("../../../icons/Icon");

var leftArrow = require("../../../icons/caretLeftTundora.svg");

var rightArrow = require("../../../icons/caretRightTundora.svg");

var styles_1 = require("./styles");

var flexStyles = require("@headspace/hs-web-style-guide/dist/flex");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var _a = flexStyles.default,
    flex = _a.flex,
    justifyContentSpaceBetween = _a.justifyContentSpaceBetween;

exports.DateInputNavBar = function (_a) {
  var onPreviousClick = _a.onPreviousClick,
      onNextClick = _a.onNextClick,
      month = _a.month,
      localeUtils = _a.localeUtils;
  var navMonth = localeUtils.formatMonthTitle(month).split(' ').reduce(function (acc, v, i) {
    var newVal = v;

    if (i === 0) {
      newVal = v.slice(0, 3);
    }

    acc.push(newVal);
    return acc;
  }, []).join(' ');
  return React.createElement("div", __assign({}, flex, justifyContentSpaceBetween, styles_1.dayPickerNavbarStyle), onPreviousClick && React.createElement("div", {
    onClick: function onClick() {
      return onPreviousClick();
    }
  }, React.createElement(Icon_1.Icon, {
    height: 8,
    width: 8,
    src: leftArrow
  })), React.createElement("div", __assign({}, font_1.uiBoldM), navMonth), onNextClick && React.createElement("div", {
    onClick: function onClick() {
      return onNextClick();
    }
  }, React.createElement(Icon_1.Icon, {
    height: 8,
    width: 8,
    src: rightArrow
  })));
};